import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { getMomentLocale } from '@helpers/locale';
import NewReply from '@components/asset/modal/tabs/workflow/attachment_details/versions_sidebar/new_reply';

const CardActions = ({
  cardEvent,
  onDelete,
  onReply,
  parentId,
}) => {
  const [showEditMessage, setShowEditMessage] = useState(false);

  const { created_at, id, updated_at, version } = cardEvent;
  const timestamp = moment(updated_at || created_at).locale(getMomentLocale()).format('LL');

  const handelReply = (e) => {
    e.stopPropagation();
    setShowEditMessage((prevState) => (!prevState));
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(id);
  };

  return (
    <>
      <p className="event-timestamp">{timestamp}</p>
      <p className="action-spacer">-</p>
      <button
        className="event-action reply-button"
        onClick={handelReply}
        type="button"
      >
        <p>Reply</p>
      </button>
      <p className="action-spacer">-</p>
      <button
        className="event-action delete-button"
        onClick={handleDelete}
        type="button"
      >
        <p>Delete</p>
      </button>
      <NewReply
        onReply={onReply}
        parentId={parentId}
        setShowEditMessage={setShowEditMessage}
        showEditMessage={showEditMessage}
        versionKey={version}
      />
    </>
  );
};

CardActions.propTypes = {
  cardEvent: PropTypes.shape({
    created_at: PropTypes.string,
    id: PropTypes.string,
    updated_at: PropTypes.string,
    version: PropTypes.string,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onReply: PropTypes.func.isRequired,
  parentId: PropTypes.string.isRequired,
};

export default CardActions;
